import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  fetchData,
  fetchDataError,
  fetchDataSuccess,
} from 'store/reducers/list';
import { LIST_TYPE } from 'constants/constants';
import API from 'api';

const FUNC = {
  [LIST_TYPE.PROJECT]: API.fetchProject,
  [LIST_TYPE.PROJECT_APPROVE]: API.fetchProjectApprove,
  [LIST_TYPE.HISTORY]: API.fetchHistory,
  [LIST_TYPE.AUTHORIZATION]: API.getAllAuthorization,
  [LIST_TYPE.USER]: API.adminGetAllUser,
};

function* fetchDataSaga(action) {
  const { params, name } = action.payload;

  if (!FUNC[name]) {
    yield put(fetchDataError({ name, error: 'API not found' }));
    return;
  }
  const res = yield call(FUNC[name], params);

  if (res.status === 200) {
    yield put(fetchDataSuccess({ name, ...res.data }));
    return;
  }

  yield put(fetchDataError({ name, error: res.message }));
}

export default function* list() {
  yield all([takeEvery(fetchData, fetchDataSaga)]);
}
